export default "__VITE_ASSET__D_j5s5Vn__"